<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <v-container
    class="text-body-2 px-6"
    style="position: relative"
  >
    <page-sub-header>{{ $t('dishesManage') }}</page-sub-header>
    <div class="flex-grow-1">
      <v-text-field
        ref="search"
        v-model="search"
        autofocus
        :placeholder="$t('dishNameNumber')"
        clearable
        hide-details
        outlined
        prepend-inner-icon="mdi-magnify"
        @click="realSearch='';search=''"
      />
    </div>
    <div
      class="pa-2"
      style="display: grid;grid-template-columns: repeat(2,minmax(0,1fr));grid-gap: 12px"
    >
      <div>
        <div class="text-subtitle-1 mt-4">
          <b>{{ $t('unshelvesMenu') }}</b>
        </div>
        <div
          class="pt-1"
          style="height: 100%;overflow-y: scroll"
        >
          <v-virtual-scroll
            :items="hideDishList"
            height="calc(100vh - 260px)"
            item-height="40px"
          >
            <template #default="{item}">
              <v-card
                :key="item.code"
                class="px-2 py-1 mt-2"
                elevation="0"
                style="display: flex;"
                @click="isShowing(item)"
              >
                <div class="text-body-1 text-truncate">
                  {{ item.code }}.
                  {{ item.optdishId[0] }}
                </div>
                <v-spacer/>
                <v-icon>
                  mdi-chevron-triple-right
                </v-icon>
              </v-card>
            </template>
          </v-virtual-scroll>
        </div>
      </div>
      <div>
        <div class="text-subtitle-1 mt-4">
          <b>{{ $t('shelvesMenu') }}</b>
        </div>
        <div
          class="pt-1"
          style="height: 100%;overflow-y: scroll"
        >
          <v-virtual-scroll
            :items="showDishList"
            height="calc(100vh - 260px)"
            item-height="40px"
          >
            <template #default="{item}">
              <v-card
                :key="item.code"
                class="px-2 py-1 mt-2"
                elevation="0"
                style="display: flex;"
                @click="isShowing(item)"
              >
                <v-icon class="mr-2">
                  mdi-chevron-triple-left
                </v-icon>
                <div
                  class="text-body-1"
                >
                  {{ item.code }}.
                </div>
                <div class="text-body-1 text-no-wrap text-truncate">
                  {{ item.optdishId[0] }}
                </div>
                <v-spacer/>
                <div class="text-no-wrap">
                  {{ $t('free') }}
                </div>
                <div class="ml-2">
                  <v-icon
                    v-if="item.isFree"
                    @click.stop="freeOrNot(item)"
                  >
                    mdi-checkbox-marked
                  </v-icon>
                  <v-icon
                    v-else
                    @click.stop="freeOrNot(item)"
                  >
                    mdi-checkbox-blank-outline
                  </v-icon>
                </div>
              </v-card>
            </template>
          </v-virtual-scroll>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
  import { sureToDelete } from '@/common/utils'
  import DishesConsumeType from '@/model/buffet/DishesConsumeType'
  import PageSubHeader from '@/composable/InK/typography/PageSubHeader'
  import PageHeader from '@/composable/InK/typography/PageHeader'

  export default {
    name: 'ShowDishCard',
    components: {
      PageHeader,
      PageSubHeader,
    },
    props: {
      filter: {},
    },
    data () {
      return {
        search: '',
        realSearch: '',
        isShow: {},
        realList: [],
      }
    },
    computed: {
      filteredList () {
        if (!this.realSearch) {
          return this.realList
        } else {
          return this.realList.filter(
            d => {
              return d.code.toLowerCase().includes(this.realSearch.toLowerCase()) ||
                (d.optdishId?.[0] ?? ' ').toLowerCase().includes(this.realSearch.toLowerCase())
            })
        }
      },
      showDishList () {
        return this.filteredList.filter(it => it.showing)
      },
      hideDishList () {
        return this.filteredList.filter(it => !it.showing)
      },
    },
    watch: {
      search (val) {
        if (val) {
          this.realSearch = val
        }
      },
      filter () {
        this.reload()
      },
    },
    mounted () {
      this.reload()
    },
    methods: {
      resetFocus () {
        this.search = ''
        this.$refs.search.focus()
      },
      async freeOrNot (item) {
        item.isFree = !item.isFree
        await DishesConsumeType.edit(item)
        await this.reload()
        this.resetFocus()
      },
      async isShowing (item) {
        item.showing = !item.showing
        if (!item.showing) {
          item.isFree = false
        }
        await DishesConsumeType.edit(item)
        await this.reload()
        this.resetFocus()
      },
      async reload () {
        this.realList = await DishesConsumeType.getList(true, this.filter)
      },
      async deleteItem () {
        await sureToDelete(() => {
          this.$emit('delete')
        })
      },
    },

  }
</script>

<style scoped>

</style>
